<section class="section-dsgvo-highlight py-5 position-relative">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-5 text-center text-lg-start">
                <div class="dsgvo-glassbox mx-auto mx-lg-0 shadow-lg">
                    <span class="badge rounded-pill bg-success px-4 py-2 mb-3 fs-6 fw-semibold">100% DSGVO-konform</span>
                    <div class="icon-wrapper mb-3">
                        <i class="fa fa-balance-scale fa-3x text-success"></i>
                    </div>
                    <h2 class="fw-bold mb-3">Transparenz und Rechtssicherheit</h2>
                    <p class="mb-0 text-secondary">
                        Maximale Sicherheit für Ihr Unternehmen – dank strikter Einhaltung aller Datenschutzgesetze.
                    </p>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="ps-lg-5">
                    <h3 class="fw-semibold text-primary mb-3">Unsere Plattform für hochwertige Firmeninformationen und E-Mail-Adressen setzt neue Standards in puncto Datenschutz.</h3>
                    <ul class="list-unstyled dsgvo-list">
                        <li>
                            <i class="fa fa-check-circle text-success me-2"></i>
                            Datenbeschaffung, -verarbeitung & -weitergabe nur im Rahmen der DSGVO
                        </li>
                        <li>
                            <i class="fa fa-check-circle text-success me-2"></i>
                            Nur umfassende und rechtskonforme Unternehmensdaten
                        </li>
                        <li>
                            <i class="fa fa-check-circle text-success me-2"></i>
                            Höchste Sicherheit bei Geschäftsanbahnung & Marketing
                        </li>
                    </ul>
                    <a class="btn btn-primary btn-lg mt-3 shadow-sm" href="#jetzt-anfragen">
                        Jetzt mehr erfahren <i class="fa fa-arrow-right ms-2"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
